import '@fs/react-scripts/polyfills'
import { appPath, mergeSentryConfig, sentryDSN } from '@fs/zion-config'
import { FrontierBaseProviders } from '@fs/zion-root'
import { Router } from '@fs/zion-router'
import * as Sentry from '@sentry/browser'
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'

import { NoticeLoading } from '@fs/zion-icon'
import App from './App'
import PortalChrome from './components/shared/PortalChrome'
import './locales'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

// Enable local feature flag development using the file "dev.flags.js"
// If that file exports anything truthy it will initialize feature flags in localhost mode
// and use the flags defined in that file, instead of flags defined in split.
const mockFlags = process.env.NODE_ENV === 'development' ? import('./dev.flags').then((m) => m.default) : undefined
const mockActivities =
  process.env.NODE_ENV === 'development' ? import('./dev.activities').then((m) => m.default) : undefined

// initialize Sentry for the app
if (sentryDSN) {
  // pass Sentry overrides to mergeSentryConfig
  Sentry.init(
    mergeSentryConfig({
      dsn: sentryDSN,
    })
  )
}

// Here we pass the mounted app path from the server to the client.
const base = appPath ? new URL(appPath).pathname : ''

// Add any app logic here as flags, languages and translations are now configured and available
const FrontierWrapper = () => {
  return (
    <Router basename={base}>
      <PortalChrome>
        <App />
      </PortalChrome>
    </Router>
  )
}

// Do not make changes to FrontierRoot, all changes should be made to FrontierWrapper
const FrontierRoot = () => {
  return (
    <React.StrictMode>
      <Suspense fallback={<NoticeLoading />}>
        <FrontierBaseProviders mockFlags={mockFlags} mockActivities={mockActivities}>
          <FrontierWrapper />
        </FrontierBaseProviders>
      </Suspense>
    </React.StrictMode>
  )
}

ReactDOM.render(<FrontierRoot />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()
